import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function AboutCTA() {
  const { lang } = useLanguage();
  const isEn = lang === 'en';
  const isJa = lang === 'ja';

  const trustItems = isEn
    ? [{ icon: 'ri-award-line', text: 'TW · JP · EU · US Patents' }, { icon: 'ri-recycle-line', text: 'EPA Recycling Permit' }]
    : isJa
    ? [{ icon: 'ri-award-line', text: '台湾・日本・EU・米国特許' }, { icon: 'ri-recycle-line', text: '環境保護局リサイクル許可' }]
    : [{ icon: 'ri-award-line', text: '台灣 · 日本 · 歐盟 · 美國專利' }, { icon: 'ri-recycle-line', text: '環保局再利用許可' }];

  const heading = isEn
    ? <>Want to Learn How PolyQ Can Help Your Industry<br className="hidden sm:block" />Adopt Circular Materials?</>
    : isJa
    ? <>聚量応用材料がどのように貴社の業界の<br className="hidden sm:block" />循環材料導入を支援できるか知りたいですか？</>
    : <>想了解聚量如何協助您的產業<br className="hidden sm:block" />導入循環材料？</>;

  const body = isEn
    ? 'Whether it\'s a technical consultation, partnership discussion, or product inquiry, our team will respond promptly to co-design the most suitable recycled material implementation plan for you.'
    : isJa
    ? '技術相談・パートナーシップ交渉・製品お問い合わせを問わず、弊社チームが迅速に対応し、最適な再生材料導入プランを共同で設計します。'
    : '無論是技術諮詢、合作洽談或產品詢價，聚量團隊將在最短時間內回覆您，共同規劃最適合的再生材料導入方案。';

  const ctaLabel = isEn ? 'Contact Us' : isJa ? 'お問い合わせ' : '聯絡我們';

  return (
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F0FAF6] via-[#EBF4FF] to-[#F5F8FB]" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-50 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.14) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] opacity-40 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.10) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mx-auto mb-6">
            <i className="ri-chat-3-line text-white text-3xl"></i>
          </div>
          <h2 className="font-bold text-neutral-dark mb-5" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}>{heading}</h2>
          <p className="text-neutral-mid mb-8" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>{body}</p>
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i>{ctaLabel}
            </Link>
            <a
              href="tel:+886958471138"
              className="inline-flex items-center gap-2 px-6 py-4 rounded-full border-2 border-brand-green text-brand-green text-[1.0625rem] font-semibold hover:bg-brand-green hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              {isEn ? 'Call Us' : isJa ? '電話する' : '直接撥打'}
            </a>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            {trustItems.map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-neutral-mid text-[1rem]">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-brand-green`}></i>
                </div>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
